// extracted by mini-css-extract-plugin
export default {"main":"Inventory_main__AH9cn"};